import {IdlocaGeneric} from "../locales/IdlocaGeneric";

export enum City {
    Tbilisi = "Tbilisi",
    Kutaisi = "Kutaisi",
    Batumi = "Batumi",
    Rustavi = "Rustavi",
    Zugdidi = "Zugdidi",
    Poti = "Poti",
    Gori = "Gori",
    Telavi = "Telavi",
    Akhaltsikhe = "Akhaltsikhe",
    Ozurgeti = "Ozurgeti",
    Borjomi = "Borjomi",
}


interface ICityConfig {
    name: City;
    locaId: IdlocaGeneric;
}

export const cityConfig: ICityConfig[] = [
    { name: City.Tbilisi, locaId: IdlocaGeneric.tbilisi },
    { name: City.Kutaisi, locaId: IdlocaGeneric.kutaisi },
    { name: City.Batumi, locaId: IdlocaGeneric.batumi },
    { name: City.Rustavi, locaId: IdlocaGeneric.rustavi },
    { name: City.Zugdidi, locaId: IdlocaGeneric.zugdidi },
    { name: City.Poti, locaId: IdlocaGeneric.poti },
    { name: City.Gori, locaId: IdlocaGeneric.gori },
    { name: City.Telavi, locaId: IdlocaGeneric.telavi },
    { name: City.Akhaltsikhe, locaId: IdlocaGeneric.akhaltsikhe },
    { name: City.Ozurgeti, locaId: IdlocaGeneric.ozurgeti },
    { name: City.Borjomi, locaId: IdlocaGeneric.borjomi },
];

